module.exports = __webpack_public_path__ + "img/warn-red.1745ed19.png";